import React, { useEffect, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import Button from 'react-bootstrap/Button';
import {
	fetchChildrenList,
	setEditChildDetails,
	editChild,
	getChildToken,
	updateParentName,
	setShowAddChild,
	setShowEditChild,
	applyLicense,
	setActiveChild,
} from '../../redux/parentDashboard/parentDashboard.actions';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import AddChild from './addChild';
import EditChild from './editChild';
import ListAnimation from '../utils/animations/list';
import Zoom from '../utils/animations/zoom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import UserTypes from '../../utils/userTypes';
import { setUserType } from '../../redux/userAuthentication/userAuth.actions';

const ParentDashboard = ({
	childrenList,
	fetchChildrenList,
	setEditChildDetails,
	editChild,
	parentName,
	getChildToken,
	updateParentName,
	setShowAddChild,
	is_parentpurchased,
	applyLicense,
	setActiveChild,
	setErrorPanel,
	whatsappNumber,
	receiveWhatsappNotification,
	setUserType,
	userType,
}) => {
	const [copiedIndex, setCopiedIndex] = useState(-1);
	const { register, handleSubmit, errors, watch } = useForm();
	const revealWhatsapp = watch('receiveWhatsappNotification');

	const applyCourseLicense = useCallback(
		async (index) => {
			await setActiveChild(index);
			applyLicense();
		},
		[applyLicense, setActiveChild],
	);
	const onSubmit = (data) => {
		updateParentName(data);
	};
	let details = JSON.parse(localStorage.getItem('userDetails'));

	const clearError = () => {
		setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
	};

	const addPopup = () => {
		clearError();
		setShowAddChild(true);
	};

	const editPopup = (child_id) => {
		clearError();
		if (window.confirm('Are you sure to delete this child profile?')) {
			editChild({ child_id, is_delete: true });
		}
	};

	useEffect(() => {
		if (userType !== UserTypes.Parent) {
			setUserType(UserTypes.Parent);
		}
	}, [setUserType, userType]);

	useEffect(() => {
		if (
			!!childrenList &&
			childrenList.length === 1 &&
			childrenList[0].is_parentpurchased &&
			!childrenList[0].is_purchased
		) {
			applyCourseLicense(0);
		}
	}, [applyCourseLicense, childrenList]);

	useEffect(() => {
		fetchChildrenList();
	}, [fetchChildrenList]);

	function copyToClipboard(e) {
		let target = e.target;
		let copyText = target.getAttribute('data-creds');

		navigator.clipboard.writeText(copyText).then(
			function () {
				setCopiedIndex(target.getAttribute('data-index'));
			},
			function () {
				/* clipboard write failed */
			},
		);
	}

	return (
		<div className="container nopadding-mobile">
			<div className="container-fluid onb">
				<div id="page-wrapper" className="dashboard-2">
					{!!childrenList && childrenList.length > 0 ? (
						<ListAnimation>
							<div className="display-flex justify-between" style={{ margin: '2%' }}>
								<h4 className="text-capital text-bold mar-no pad-no">
									Hello {parentName || details?.full_name}!
								</h4>
								<Zoom>
									<button className="btn btn-primary btn-kid-switch" onClick={addPopup}>
										Add Child <FontAwesomeIcon icon={faUserPlus} size="lg" />
									</button>
								</Zoom>
							</div>
							{childrenList[0].is_parentpurchased && (
								<div className="alert alert-success display-flex justify-content-center">
									<p>
										As you have purchased a course for kids, you can assign this license
										to your existing child profiles (click on the child profile) or you
										can create a new child profile (click on 'Add Child').
									</p>
								</div>
							)}
							<div className="kid-index">
								{childrenList.map((child, i) => {
									let {
										child_photo,
										child_name,
										child_grade,
										child_id,
										final_score,
										is_parentpurchased,
										is_purchased,
										child_pin,
										child_user_name,
									} = child;
									return (
										<div key={child_id} className="kid-index-item">
											<div className="kid-index-cont">
												<div
													alt={child_name}
													className="kid-index-cimg"
													style={{
														backgroundImage: `url(${
															child_photo || '/assets/img/kid-avatar-boy.svg'
														})`,
													}}
												>
													<Zoom>
														<button
															className="btn btn-sm btn-outline-danger btn-kid-remove"
															onClick={() => editPopup(child_id)}
														>
															&times;
														</button>
													</Zoom>
												</div>

												<div className="kid-index-info-btn">
													<div className="kid-index-info">
														<h4 className="kid-index-cname">{child_name}</h4>
														<div className="kid-index-grade-score">
															<span className="detail-item">
																Grade <strong>{child_grade}</strong>
															</span>
															{!!final_score && (
																<span className="detail-item">
																	Score <strong>{final_score}%</strong>
																</span>
															)}
															<span>
																<strong>Username:</strong>
																{child_user_name}{' '}
															</span>
															<span>
																<strong>Pin:</strong>
																{child_pin}{' '}
															</span>
														</div>
													</div>

													<div class="kid-index-credentials">
														<button
															onClick={copyToClipboard}
															className="copy-Credentials"
															data-index={i}
															data-creds={`Visit ${window.location.origin}/junior/signin and use credentials username: ${child_user_name} and pin: ${child_pin} to signin as ${child_name}.`}
														>
															{parseInt(copiedIndex, 10) === i
																? 'Copied!'
																: 'Click to Copy Login Credentials'}
														</button>
													</div>

													<div className="kid-index-btn-container">
														{is_parentpurchased && !is_purchased ? (
															<button
																className="btn btn-primary btn-kid-switch"
																onClick={() => applyCourseLicense(i)}
															>
																APPLY LICENSE
															</button>
														) : (
															<button
																className="btn btn-primary btn-kid-switch"
																onClick={() => getChildToken({ child_id, id: i })}
															>
																TAKE TEST
															</button>
														)}
														<button
															className="btn btn-light-useredit"
															onClick={() => setEditChildDetails(child)}
														>
															Edit
														</button>
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</ListAnimation>
					) : (
						<ListAnimation className="signupGreeting">
							<div className="display-flex align-items-top justify-between">
								<div className="side-content">
									<div className="step-triangle"></div>
									<h1 className="parentGreeting">Hello {parentName}!</h1>
									{is_parentpurchased ? (
										<h5 className="alert alert-success" style={{ width: '90%' }}>
											As you have purchased a course for kids, you can now create a child
											profile to assign this course. This will give your child a separate
											account to login to and access his/her course!
										</h5>
									) : (
										<h3>
											You can now create one or more child profiles for the STEP Online
											Olympiad.
										</h3>
									)}
									<div className="kids-course-logos">
										<div className="display-flex justify-between kids-course-logos-1">
											<img
												src={'/assets/img/STEPATHON_Junior_Plus.jpg'}
												alt="STEPATHON_Junior_Plus"
											/>
											<p>
												STEPathon Junior Plus is a paid speaking assessment, where an expert
												STEP Coach will assess your child over a 30 minute video call, which
												can be scheduled at your convenience. A detailed personalised report
												will be provided at the end of the assessment.
											</p>
										</div>
										<div className="display-flex justify-between kids-course-logos-2">
											<p>
												STEPathon Junior is a free online assessment for Grades 3-10 which
												tests reading and listening skills. It is a 25 minute test, with a
												detailed report and a percentile score based on data from last
												year's STEP Olympiad, India's first tablet-based English Olympiad.
											</p>
											<img
												src={'/assets/img/STEPATHON_Junior.jpg'}
												className="noborder"
												alt="STEPATHON_Junior"
											/>
										</div>
									</div>
								</div>
								<div className="side-form">
									{!parentName || !/^[a-zA-Z\s\.]+$/i.test(parentName) ? (
										<form onSubmit={handleSubmit(onSubmit)}>
											<div className="form-group" style={{ marginTop: '10px' }}>
												<label className="control-label" htmlFor="parentName">
													Please enter your name:
												</label>
												<input
													type="text"
													className="form-control"
													name="parentName"
													ref={register({
														required: true,
														// eslint-disable-next-line no-useless-escape
														pattern: /^[a-zA-Z\s\.]+$/i,
													})}
												/>

												<span className="profileError">
													{errors.parentName?.type === 'required' && 'Name is required'}
												</span>
											</div>
											<div className="d-flex flex-row">
												<div className="form-group">
													<label
														className="label-title"
														htmlFor="receiveWhatsappNotification"
														style={{ maxWidth: '80%' }}
													>
														Do you wish to receive updates on WhatsApp?
													</label>

													<input
														style={{ display: 'inline-block', width: '15px' }}
														type="checkbox"
														name="receiveWhatsappNotification"
														className="form-control"
														value="1"
														defaultChecked={!!receiveWhatsappNotification}
														ref={register}
													/>
												</div>
											</div>
											{revealWhatsapp ||
											typeof revealWhatsapp === 'undefined' ||
											!!whatsappNumber ? (
												<div className="form-group">
													<label className="control-label" htmlFor="whatsappNumber">
														WhatsApp Number
													</label>
													<input
														type="text"
														className="form-control"
														name="whatsappNumber"
														ref={register({
															required: true,
															pattern: /^[789]\d{9}$/,
														})}
														defaultValue={whatsappNumber}
													/>

													<span className="profileError">
														{errors.whatsappNumber?.type === 'pattern' &&
															'Incorrect mobile number'}
													</span>
													<span className="profileError">
														{errors.whatsappNumber?.type === 'required' &&
															'Whatsapp number required'}
													</span>
												</div>
											) : null}

											<Button
												type="submit"
												variant="primary"
												style={{ transform: 'translate(100%)' }}
											>
												Continue
											</Button>
										</form>
									) : (
										<AddChild formType="inline" />
									)}
								</div>
							</div>
						</ListAnimation>
					)}
				</div>
			</div>
			<EditChild />
			<AddChild />
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		childrenList,
		parentName,
		showAddChild,
		showEditChild,
		is_parentpurchased,
	} = state.rootReducer.parentDetails;
	const {
		whatsappNumber,
		receiveWhatsappNotification,
	} = state.rootReducer.profileDetails;
	const { newUser, userType } = state.rootReducer.loginDetails;
	return {
		childrenList,
		parentName:
			state.rootReducer.profileDetails.fullName ||
			state.rootReducer.userDetails.full_name ||
			parentName,
		showAddChild,
		showEditChild,
		newUser,
		is_parentpurchased,
		whatsappNumber,
		receiveWhatsappNotification,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchChildrenList: () => dispatch(fetchChildrenList()),
		setEditChildDetails: (obj) => dispatch(setEditChildDetails(obj)),
		editChild: (obj) => dispatch(editChild(obj)),
		getChildToken: (val) => dispatch(getChildToken(val)),
		updateParentName: (val) => dispatch(updateParentName(val)),
		setShowAddChild: (val) => dispatch(setShowAddChild(val)),
		setShowEditChild: (val) => dispatch(setShowEditChild(val)),
		applyLicense: () => dispatch(applyLicense()),
		setActiveChild: (val) => dispatch(setActiveChild(val)),
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(ParentDashboard);
